import {useSelector} from "react-redux";

export const useSelectToken = () => {
    return useSelector(({ auth }) => auth?.authToken)
}